import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { DataQuality, RegistrationTableRow } from '../../../../models/performance-view.model';
import { PaginationStore } from '../../../../store/signal-stores/pagination.signal-store';
import { ExportCSVService } from '../../../services/export-csv.service';
import { BaseTableComponent } from '../../../shared/components/base-table/base-table.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { TableStateComponent } from '../../../shared/components/table-state/table-state.component';
import { REGISTRATION_PERFORMANCE_COLUMNS, RegistrationColumnKey } from './registration-details-table-config';

@Component({
  selector: 'fdr-past-performance-ui-registration-details',
  standalone: true,
  imports: [PaginationComponent, TableStateComponent, TranslateModule, DecimalPipe],
  providers: [PaginationStore],
  templateUrl: './registration-details.component.html',
  styleUrl: './registration-details.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationDetailsComponent extends BaseTableComponent<RegistrationTableRow, RegistrationColumnKey> {
  private readonly exportCSVService = inject(ExportCSVService);
  readonly store = inject(Store);
  readonly isLoading = input<boolean>(false);

  constructor() {
    super(signal(REGISTRATION_PERFORMANCE_COLUMNS));
  }

  public exportCSV() {
    this.exportCSVService.exportFromTable(this.processedRows(), this.columnsSignal(), 'PastDispatches');
  }

  getDataQualityTranslationKey(dataQuality: DataQuality): string {
    if (dataQuality === 'Final') {
      return 'PD.TABLE.FINAL';
    }
    return 'PD.TABLE.PRELIMINARY';
  }
}
